const getInlineAdConfig = (adCount) => [{
  type: 'DESKTOP_INLINE_ADVERT',
  props: {
    extraClassNames: {
      '-full-width': true,
    },
    id: `refresh-inline_${adCount}`,
    label: 'Advertisement - Article continues below',
    slotSize: [[300, 250], 'fluid'],
    sizeMapping: [
      {
        viewport: [0, 0],
        slot: [],
      },
      {
        viewport: [980, 0],
        slot: [[970, 250], [970, 90], [728, 90], 'fluid'],
      },
    ],
    ampSlotSize: [], // has to come after slotSize
    ampSizeMapping: [], // has to come after sizeMapping
    targeting: {
      position: `inline_${adCount}`,
      placement: `inline_${adCount}`,
      refresh: 'yes',
    },
  },
}];

const getDigitekaConfig = ({
  monetising, breakpoints, viewport, amp,
}) => [{
  type: 'DIGITEKA',
  props: {
    monetising,
    breakpoints,
    viewport,
    amp,
  },
}];

const getSideAdConfig = (adCount) => (
  [{
    type: 'DESKTOP_SIDE_ADVERT',
    props: {
      extraClassNames: {
        '-sidebar-ad': true,
      },
      id: `refresh-right_${adCount}`,
      label: 'Advertisement',
      targeting: {
        position: `right_${adCount}`,
        placement: `right_${adCount}`,
        refresh: 'yes',
      },
      type: 'slot-2',
    },
  }]
);

const getDesktopAdsConfig = (adCount) => [].concat(getSideAdConfig(adCount), getInlineAdConfig(adCount));

const getMobileInlineAdConfig = (adCount) => {
  const ampSlotSize = adCount > 1 ? [[320, 480], [300, 250]] : [300, 250];
  return [{
    type: 'MOBILE_INLINE_ADVERT',
    props: {
      extraClassNames: {
        '-full-width': true,
        'hide-desktop': true,
      },
      id: `refresh-inline_${adCount}`,
      label: 'Advertisement - Article continues below',
      slotSize: [[300, 250], 'fluid'],
      sizeMapping: [
        {
          viewport: [768, 0],
          slot: [[728, 90], [300, 250], 'fluid'],
        },
        {
          viewport: [980, 0],
          slot: [],
        },
      ],
      ampSlotSize, // has to come after slotSize
      ampSizeMapping: [], // has to come after sizeMapping
      targeting: {
        position: `inline_${adCount}`,
        placement: `inline_${adCount}`,
        refresh: 'yes',
      },
    },
  }];
};

const getMobileAdsConfig = (adCount) => [].concat(getMobileInlineAdConfig(adCount));

const getTeadsAdConfig = () => (
  [{
    type: 'TEADS',
    props: {
      extraClassNames: {
        '-no-background': true,
        'teads-amp': true,
      },
      id: 'teads_amp',
      label: '',
      targeting: {
        position: 'teads_amp',
        placement: 'teads_amp',
        refresh: 'no',
      },
      ampSlotSize: [300, 1],
      ampSizeMapping: [],
    },
  }]
);

const getNewsletterConfig = ({ newsletterConfig, viewport, breakpoints }) => [{
  type: 'NEWSLETTER',
  props: {
    newsletterConfig,
    viewport,
    breakpoints,
    mainTitle: null,
    extraClassNames: {
      '-standalone': true,
    },
  },
}];

const getSubscriptionConfig = ({ promoBoxSettings, viewport, breakpoints }) => [{
  type: 'SUBSCRIBE',
  props: {
    promoBoxSettings,
    breakpoints,
    extraClassNames: {
      '-standalone': true,
    },
    viewport,
  },
}];

const getNewsletterSubscriptionConfig = ({
  promoBoxSettings, newsletterConfig, viewport, breakpoints,
}) => (
  [{
    type: 'SUBSCRIBE_NEWSLETTER',
    props: {
      newsletterConfig,
      promoBoxSettings,
      viewport,
      breakpoints,
    },
  }]
);

const getGalleryItemDescriptionAdConfig = (adCount) => (
  [{
    type: 'GALLERY_IN_DESCRIPTION_AD',
    props: {
      targeting: {
        position: `gallery_inline_${adCount}`,
        placement: `gallery_inline_${adCount}`,
        refresh: 'yes',
      },
      slotSize: [[300, 250], 'fluid'],
      sizeMapping: [
        {
          viewport: [0, 0],
          slot: [],
        },
        {
          viewport: [980, 0],
          slot: [[300, 250], 'fluid'],
        },
      ],
      ampSizeMapping: [],
      extraClassNames: {
        '-float-right': true,
        '-gallery-in-body-ad': true,
      },
    },
  }]
);

const getGalleryDianomiBlockDesktopAdConfig = ({ breakpoint, dianomi, componentCount }) => (
  [{
    type: 'DIANOMI_BLOCK_DESKTOP',
    options: {
      amp: false,
      breakpoint: 'desktop',
      breakpointRange: breakpoint,
      dianomi,
      index: componentCount,
    },
  }]
);

const getGalleryDianomiBlockMobileAdConfig = ({ amp, breakpoint, dianomi }) => (
  [{
    type: 'DIANOMI_BLOCK_MOBILE',
    options: {
      amp,
      breakpoint: 'mobile',
      breakpointRange: breakpoint,
      dianomi,
    },
  }]
);

export default {
  getInlineAdConfig,
  getSideAdConfig,
  getDesktopAdsConfig,
  getMobileInlineAdConfig,
  getMobileAdsConfig,
  getTeadsAdConfig,
  getDigitekaConfig,
  getNewsletterConfig,
  getSubscriptionConfig,
  getNewsletterSubscriptionConfig,
  getGalleryItemDescriptionAdConfig,
  getGalleryDianomiBlockDesktopAdConfig,
  getGalleryDianomiBlockMobileAdConfig,
};
